module.exports = __webpack_public_path__ + "img/016.9a0a0f9a.jpg";